export default __webpack_public_path__ + "d81eaee73e7571ee31900304f4d180e5.png";